(() => {
  if (window.VVStudioEntryReady) return;
  window.VVStudioEntryReady = true;
  function position() {
    document.querySelectorAll('main media-gallery .vv-studio-badge').forEach(button => {
      const gallery = button.closest('media-gallery');
      const image = [...gallery.querySelectorAll('.product-media-container')].find(item => item.getBoundingClientRect().width > 0 && item.getBoundingClientRect().height > 0);
      if (!image) return;
      const a = image.getBoundingClientRect(), b = gallery.getBoundingClientRect();
      button.style.top = `${a.bottom - b.top - button.offsetHeight - 16}px`;
      button.style.bottom = 'auto';
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('main media-gallery .vv-studio-badge');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const productId = button.dataset.vvProductId;
    const form = document.querySelector(`main product-form-component[data-product-id="${productId}"]`);
    const guard = window.VelvoriaCaseSelection;
    if (guard && !guard.canSubmit(form)) return;
    const id = form?.querySelector('[name="id"]')?.value;
    let config;
    try { config = JSON.parse(button.parentElement.querySelector('.vv-studio-product-media').textContent); } catch { return; }
    const variant = config.variants.find(item => String(item.id) === String(id));
    if (!variant?.available) return;
    const url = new URL(button.href, location.origin);
    url.searchParams.set('vv_variant', variant.id);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    location.assign(url.href);
  }, true);
  window.addEventListener('resize', position);
  document.addEventListener('variant:update', () => requestAnimationFrame(position));
  new ResizeObserver(position).observe(document.documentElement);
  position();
})();
